// extracted by mini-css-extract-plugin
export default {"Wrapper":"PopupAssignCompetition_Wrapper__IvgPK"};